module.exports = __webpack_public_path__ + "img/1.a6e7fb52.jpg";